export default "__VITE_ASSET__c777968e__"